const vehicleReport = {
  title: 'Vehicle Trips Report',
  description: 'Provides statistical information on the activity of individual drivers.',
  table: {
    headers: {
      id: 'Id',
      driver: 'Driver',
      supplier: 'Supplier',
      vehicle: 'Vehicle',
      zones: 'Zones',
      locations: 'Locations',
      profiles: 'Profiles',
      attributes: 'Attributes',
      driverShifts: 'Shift',
      trips: 'Trips',
      departureTime: 'DEPARTURE TIME',
      start: 'Start',
      end: 'End',
      hours: 'Hours',
      reservations: 'Total Bookings',
      tripsDuration: 'Trips Duration',
      avgTripsDuration: 'AVG Trips Duration',
      idleTime: 'Idle Time',
      idleTimeRatio: 'Idle Ratio',
      tripsDistance: 'Trips Distance',
      avgTripsDistance: 'AVG Trips Distance',
      deadheadDistance: 'Deadhead Distance',
      deadheadDistanceRatio: 'Deadhead Ratio',
      loadedDistance: 'Loaded Distance',
      earningPerHour: 'Earning Per Hour',
      totalEarnings: 'Total Earnings',
    },
    driver: 'Driver',
    Amount: 'Amount',
    unassignedTrips: 'Unassigned',
    yes: 'YES',
    no: 'NO',
  },

  filter: {
    export: 'Export',
    driver: 'Driver',
    supplier: 'Supplier',
    car: 'Vehicle',
    zones: 'Zones',
    locations: 'Locations',
    airportLocations: 'Airport Locations',
    profiles: 'Profiles',
    attributes: 'Attributes',
    submit: 'Filter',
    clear: 'Clear Filter',
    driverShifts: {
      title: 'Drivers Shifts',
      options: {
        withShifts: 'With Shift',
        withoutShifts: 'Without Shift',
      },
    },
    validation: {
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
    },
  },

  vehicleSummary: {
    total: 'Vehicles',
    totalTrips: 'Total Trips',
    totalReservation: 'Total Bookings',
    assignedTrips: 'Assigned Trips',
    notAssignedReservations: 'Unassigned Bookings',
    notAssignedTrips: 'Unassigned Trips',
    assignedReservations: 'Assigned Bookings',
    averageTripDistance: 'AVG Trip Distance',
    averageTripDeadheadDistance: 'AVG Trip Deadhead Distance',
    averageTripDuration: 'AVG Trip Duration',
    averageIdleTime: 'AVG Idle Time',
    averageIdleTimeRatio: 'AVG Idle Ratio',
    averageTripsPerDriver: 'AVG Trips per Driver',
    avarageBookingsPerDriver: 'AVG Bookings per Driver',
    averageEarningsPerDriver: 'AVG Earnings Per Driver',
    loadedDistance: 'Loaded Distance',
    totalEarnings: 'Total Earnings',
    averageTripEarnings: 'AVG Trip Earnings',
    totalDrivers: 'Total Drivers',
    totalVehicles: 'Total Vehicles',
    rideShareTrips: 'Shared Trips',
    rideShareReservations: 'Shared Bookings',
    driversWithShifts: 'Drivers with shifts',
    earningPerHour: 'Earning Per Hour',
    canceledTrips: 'Canceled Trips',
    canceledReservations: 'Canceled Bookings',
    onTimePerformance: 'On Time Performance',
    noShow: 'No Show',
    averageDeadhead: 'AVG Deadhead',
    activeDrivers: 'Active Drivers',
    inrouteTrips: 'En-route Trips',
    totalShiftsHours: 'Total Drivers Hours',
  },

  form: {
    dateEnd: 'Date End',
    dateStart: 'Date Start',
  },
  export: 'vehicle report',
};

export default vehicleReport;
